/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Report_CheckInputs */



/**
* | output |
* | --- |
* | "Feedback on this conversation" |
*
* @param {Chat_Quick_Report_CheckInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_report_check = /** @type {((inputs?: Chat_Quick_Report_CheckInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Report_CheckInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Feedback over gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un retour sur cette conversation")
	return /** @type {LocalizedString} */ ("Feedback on this conversation")
});